/* Component to display all the 2nd unit Callsheet data
 * Contains the LocationsPage, TalentPage, BgPage,
   SchedulePage, NotesPage, CrewCallsPage, AdvancedSchedPage, 
   WalkiesPage, HospitalPage (mobile only) 
   and ContactsPage (mobile only) Components.
   */
import React, { useMemo, useState } from "react";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useHistory } from "react-router-dom";
import { Image } from "react-bootstrap";
import TopBox from "../../components/TopBox";
import {useCrewInfoContext,
} from "../../contexts/BaseCallContext";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import { PostDropdown } from "../../components/PostDropdown";
import TalentPage from "./callsheetSections2/TalentPage2";
import BgPage from "./callsheetSections2/BgPage2";
import SchedulePage from "./callsheetSchedule2/SchedulePage2";
import LocationsPage from "./callsheetSections2/LocationsPage2";
import NotesPage from "./callsheetSections2/NotesPage2";
import AdvancedSchedPage from "./callsheetSchedule2/AdvancedSchedPage2";
import ContactsPage from "./callsheetSections2/MobileViewContactsPage2";
import WalkiesPage from "./callsheetSections2/WalkiesPage2";
import HospitalPage from "./callsheetSections2/HospitalPage2";
import sceneblue2 from "../../assets/sceneblue2.png"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import btnStyles from "../../styles/Button.module.css";
import styles from "../../styles/Callsheets.module.css";
import toast from "react-hot-toast"; 
import CrewCallsPage2 from "./callsheetSections2/CrewCallsPage2";
import { CopyLink } from "../../components/CopyLink";
import InfoCall2 from "./info2/InfoCall2";

const CallSheet2 = (props) => {
  // eslint-disable-next-line
  const host = useHostName();
  const cUser = useCurrentUser();
  const crewInfoOne = useCrewInfoContext();
  const history = useHistory();
  // const { id: routeDayId } = useParams();
  const [showLink, setShowLink] = useState(false);
  const [showHos, setShowHos] = useState(false);
  const [showContacts, setShowContacts] = useState(false);
  const [showLoc, setShowLoc] = useState(false);
  const [showWalkies, setShowWalkies] = useState(false);
  const [showSched, setShowSched] = useState(false);
  const [showTalent, setShowTalent] = useState(false);
  const [showBg, setShowBg] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [showCrew, setShowCrew] = useState(false);
  const [showAdvanSched, setShowAdvanSched] = useState(false);
  const queryString = window.location.search;
  const [showInfo, setShowInfo] = useState(false); 

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  // const urlDayId = params.get("day_id");
  const epi = params.get("episode");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  const firstname = cUser?.first_name;
  const lastname = cUser?.last_name;

  const {
    production_name,
    production_company,
    company_phone,
    company_email,
    company_address_line_1,
    company_address_line_2,
    company_address_line_3,
    company_address_line_4,
    company_logo,
    producer_name,
    producer_phone,
    pro_coordinator_name,
    pro_coordinator_phone,
  } = crewInfoOne || {};

  const {
    scenes,
    // eslint-disable-next-line
    handleMount,
    crewcalls,
    cast,
    callsheet,
    background,
    // info
    id,
    day,
    date,
    day_id,
    unit_call,
    talent_call,
    shoot_call,
    breakfast,
    lunch,
    wrap,
    location_2_name,
    location_3_name,
    location_4_name,
    location_5_name,
    location_1_address,
    location_2_address,
    location_3_address,
    location_4_address,
    nearest_hospital,
    hospital_address_line_1,
    hospital_address_line_2,
    hospital_address_line_3,
    hospital_address_line_4,
    important_info,
    transport_info,
    department_info,
  } = props;

  const uniqueLocationScenes = useMemo(() => {
    const results = scenes?.results ?? [];
    if (!Array.isArray(results) || results.length === 0) return scenes;

    const newLocs = [];
    const seenLocationKeys = new Set();
    const norm = (v) => (typeof v === "string" ? v.trim().toLowerCase() : "");

    for (const scene of results) {
      const locationValue =
        scene?.location_address?.trim() || scene?.filming_location?.trim() || "";
      const locationKey = norm(locationValue);

      // If both are empty, don't collapse multiple blanks into one
      if (!locationKey) {
        newLocs.push(scene);
        continue;
      }

      if (seenLocationKeys.has(locationKey)) continue;
      seenLocationKeys.add(locationKey);
      newLocs.push(scene);
    }

    return { ...scenes, results: newLocs };
  }, [scenes]);

  const firstLoc =
    scenes?.results?.[0]?.location_address?.trim() ||
    scenes?.results?.[0]?.filming_location?.trim() ||
    "";

  const handleEdit = () => {
    history.push(
      `/${localStorage.getItem("projectSlug")}/callsheet2unit/edit/${day_id}/${
        epi && project && episodeTitle
          ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
          : ""
      }`
    );
  };

  // 1. REQUEST needs 2nd unit para
  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`callsheetsnew/${id}/`);
        history.goBack();
        toast.success(`Callsheet Deleted`);
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/callsheetsnew/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        history.goBack();
        toast.success(`Callsheet Deleted Successfully!`);
      }
    } catch (err) {}
  };

  // Advanced Schedule day_id is stored in hospital_address_line_4
  // (when absent, Advanced Schedule is not shown).
  const advancedScheduleDayId = hospital_address_line_4;

  return (
    <div className={`${styles.White} px-3`}>
      <TopBox
        second="2ND UNIT - CALLSHEET"
        title2={`Day ${day} -`}
        title3={date}
        episodeTitle={`Episode ${episodeTitle}`}
      />
      {/* back - edit*/}
      <Row className="py-0 my-1" >
        <Col xs={3} className="py-0 my-0">
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue}`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Col>
        {/* info button */}
        <Col xs={3} className="py-0 px-0 my-0 text-center">
        {cUser &&
            cUser?.groups?.length > 0 &&
            (cUser?.groups[0]?.name === "Admin" ||
              cUser?.groups[0]?.name === "Superadmin") && (
        <Button
              className={`text-center ${btnStyles.Order} ${btnStyles.Button}`}
              onClick={() => setShowInfo((showInfo) => !showInfo)}
            >
              IMPORTANT
        </Button>
        )}
        </Col>
        {/* copy link */}
        <Col xs={3} className="text-center px-0 mx-0">
        {cUser &&
            cUser?.groups?.length > 0 &&
            (cUser?.groups[0]?.name === "Admin" ||
              cUser?.groups[0]?.name === "Superadmin") && (
        <Button
              className={`${btnStyles.OrderS} ${btnStyles.Button}`}
              onClick={() => setShowLink((showLink) => !showLink)}
            >
              COPY LINK
        </Button>
        )}
        </Col>
        <Col className={`text-right ${styles.Icon}`} xs={3}>
        {cUser &&
            cUser?.groups?.length > 0 &&
            (cUser?.groups[0]?.name === "Admin" ||
              cUser?.groups[0]?.name === "Superadmin") && (             
                <PostDropdown
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />)}
              </Col>
      </Row>
      {!showInfo ? "" : <InfoCall2 />}
      {!showLink ? (
          ""
        ) : (
          <CopyLink/>
        )}
      {/* MEDIUM  */}
      <div className="d-none d-md-block mt-1">
        {/* country using location_5_name */}
        {location_5_name && (
          <Row>
          <Col
            className={`text-center `}
            md={{ span: 4, offset: 4 }}
          >
            <div className={`mx-3 pb-0 px-2 ${styles.CountryBack}`}>
            <h4 style={{ textTransform: 'uppercase'}} className={` ${styles.vv}`}>
              {location_5_name} SHOOT</h4>
            </div>
          </Col>
        </Row>
        ) }
        <Row className="px-3">
          <Col md={4}>
            <Row className="mb-1 mt-5">
              <Col xs={{ span: 8, offset: 0 }}>
                <h5 className={`mb-1 pl-0 ${styles.WhiteAquaProU}`}>
                  {production_company}{" "}
                </h5>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  {company_address_line_1}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  {company_address_line_2}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  {company_address_line_3}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  {company_address_line_4}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  Phone {company_phone}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  Email {company_email}{" "}
                </p>
              </Col>
            </Row>
            {/* Producer */}
            <Row className="mt-3">
              <Col xs={12}>
                <p className={`mb-1`}>
                  <span className={`${styles.BoldU}`}>Producer:</span>{" "}
                </p>
              </Col>
              <Col xs={12}>
                <p className={`${styles.WhiteAqua} mb-1`}>
                  {producer_name} - {producer_phone}{" "}
                </p>
              </Col>
            </Row>
            {/* pro-cor */}
            <Row>
              <Col xs={12}>
                <p className={`mb-1`}>
                  <span className={`${styles.BoldU}`}>Pro Cord:</span>
                </p>
              </Col>
              <Col xs={12}>
                <p className={`${styles.WhiteAqua} mb-1`}>
                  {pro_coordinator_name} - {pro_coordinator_phone}
                </p>
              </Col>
            </Row>
            {/* Director */}
            <Row>
              <Col xs={12}>
                <p className={`mb-1`}>
                  <span className={`${styles.BoldU}`}>2nd Unit Director:</span>
                </p>
              </Col>
              <Col xs={12}>
                <p className={`${styles.WhiteAqua} mb-1`}>
                  {location_1_address} - {location_2_address}{" "}
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={4} className="text-center pb-0">
          <div>
          <Col
            className={`mb-1 text-center `}
          >
            <span className={` ${styles.MovieName}`}>{production_name}</span>
          </Col>
          </div>
            {/* logo */}
            <div className={`mt-0`}>
                {company_logo ? (
                  <>
                    <div className="px-3">
                      <Image
                        className={styles.Logo}
                        src={company_logo}
                        alt="logo image"
                      />
                    </div>
                  </>
                ) :
                <>
                    <div className="px-3">
                      <Image
                        className={styles.Logo}
                        src={sceneblue2}
                        alt="logo image"
                      />
                    </div>
                  </> 
                }
              </div>
            <h2 className="mt-3 mb-0 pb-0"> </h2>
            <div className="mt-2 mb-0 pb-0 mx-lg-5">              
              <p className={`${styles.UnitCallMedDate}`}>
              {`Day ${day}`}
              </p>
              <p className={`${styles.UnitCallMedDate}`}>
                {date}
              </p>
              {/* <p className={`px-0 mt-2 ${styles.UnitCallMedDate}`}>{date} </p> */}
            </div>
            <div className={`mt-3 py-0`}>
              <Row>
              <Col md={{span: 8, offset: 2}} >
              <h5 className={`${styles.CountryBack} mb-0 pb-0`}>2ND UNIT</h5>
              </Col>
              </Row>
            </div>
            <div className={`mt-3 mx-3 pb-0 px-2 ${styles.Border2}`}>
              <h2 className={`px-1 my-0 pb-0 ${styles.UnitCallMed}`}>Unit Call</h2>
              <h2 className={`${styles.UnitCallMed}`}>{unit_call} </h2>
            </div>
            <div>
            <p className={`mt-1 ${styles.Bold}`} >Weather </p>
            <p className={`${styles.WhiteAqua} mb-1`} >{location_2_name} </p>
            </div>
          </Col>
          <Col className="pl-5 mt-5" md={4}>
          <Row>
          <Col xs={2} ></Col>
          <Col xs={10}>
          <Row>
          <Col xs={7} className='px-0'>
          <p className={`mb-1 ${styles.BoldV}`} >Sunrise:</p>
          <p className={`mb-1 ${styles.Bold}`} >Sunset:</p>
          </Col>
          <Col xs={5} className='px-0'>
          <p style={{ textTransform: 'uppercase'}} className={`${styles.WhiteAqua} mb-1`} >{location_3_name}</p>
          <p style={{ textTransform: 'uppercase'}} className={`${styles.WhiteAqua} mb-1`}>{location_4_name}</p>
          </Col>
          </Row>
          {/* <Weather 
            temp2={location_2_name}
            rise2={location_3_name}
            sunset2={location_4_name}
            weather_location={weather_location} /> */}
            <Row>
              <Col xs={7} className='px-0'>
                <p className={`mb-1`}>
                  <span className={`${styles.BoldV}`}>Talent Call:</span>{" "}
                </p>
                <p className={`mb-1`}>
                  <span className={`${styles.Bold}`}>First Shot:</span>
                </p>
                <p className={`mb-1`}>
                  <span className={`${styles.Bold}`}>Breakfast:</span>
                </p>
                <p className={`mb-1`}>
                  <span className={`${styles.Bold}`}>Lunch:</span>
                </p>
                <p className={`mb-1`}>
                  <span className={`${styles.Bold}`}>Est. Wrap:</span>
                </p>
              </Col>
              <Col xs={5} className='px-0'>
                <p className={`${styles.WhiteAqua} mb-1`}>{talent_call} </p>
                <p className={`${styles.WhiteAqua} mb-1`}>{shoot_call}</p>
                <p className={`${styles.WhiteAqua} mb-1`}>{breakfast}</p>
                <p className={`${styles.WhiteAqua} mb-1`}>{lunch}</p>
                <p className={`${styles.WhiteAqua} mb-1`}>{wrap}</p>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className='px-0'>
              <p className={`mb-0 mt-3 ${styles.BoldU}`}>Nearest Hospital:
            </p>
                <p className={`mb-1 ${styles.WhiteAqua}`}>
                  {nearest_hospital}{" "}
                </p>
                <p className={`mb-1 ${styles.WhiteAqua}`}>
                  {hospital_address_line_1}{" "}
                </p>
                <p className={`mb-1 ${styles.WhiteAqua}`}>
                  {hospital_address_line_2}{" "}
                </p>
                <p className={`mb-1 ${styles.WhiteAqua}`}>
                  {hospital_address_line_3}
                </p>
              </Col>
            </Row>
          </Col>
          </Row>
          </Col>
        </Row>
        {/* 2nd row */}
        <Row className="px-3">
          <Col xs={4}>
            {/* 1st AD */}
            <Row className="mt-2">
              <Col xs={12}>
                <p className={`mb-1`}>
                  <span className={`${styles.BoldU}`}>2nd Unit 1st AD:</span>
                </p>
              </Col>
              <Col xs={12}>
                <p className={`${styles.WhiteAqua} mb-1`}>
                  {location_3_address} - {location_4_address}{" "}
                </p>
              </Col>
            </Row>
          </Col>
          <Col xs={4}>
            <div
              className={`mt-0 mx-3 py-0 px-2 text-center ${styles.Border2}`}
            >
              <p className={`mb-0 pt-1`}>
                <span className={`${styles.BoldU}`}>First Location</span>
              </p>
              <h5 className={`mb-1 ${styles.WhiteAqua}`}>{firstLoc} </h5>
            </div>
          </Col>
          <Col xs={4} className="pl-4" >
            <Row>
            <Col xs={2}></Col>
            <Col xs={10} >
                <p className={`mb-0 pl-2 mt-2 ${styles.BoldU}`}>
              User:
                </p>
                <p className={`mb-0 pl-2 mt-2 ${styles.WhiteAqua}`}>
                  {firstname} {lastname}
                </p>
            </Col>
            </Row>
            {/* {yourCastUser ? (
              <>
                <p className={`mb-0 mt-2 ${styles.WhiteAqua}`}>
                  <span className={`${styles.Bold}`}>Username: </span>
                  {yourCastUser} {currentUser}{" "}
                </p>
              </>
            ) : (
              <>
                <p className={`mb-0 mt-2 ${styles.WhiteAqua}`}>
                  <span className={`${styles.Bold}`}>Username: </span>
                  {currentUser}{" "}
                </p>
              </>
            )} */}
          </Col>
        </Row>
        {/* Locations */}
        <LocationsPage callsheet={callsheet} scenes={uniqueLocationScenes} />
        {/* Schedule  */}
        <SchedulePage scenes={scenes} />
        {/* Talent  */}
        <TalentPage handleMount={handleMount} cast={cast} />
        {/* BG AND STANDINS */}
        <BgPage background={background} handleMount={handleMount} />
        {/* Crew */}
        <CrewCallsPage2 crewcalls={crewcalls} />
        {/* Notes */}
        <NotesPage
          important_info={important_info}
          transport_info={transport_info}
          department_info={department_info}
        />
        {/* Advanced Schedule  */}
        {advancedScheduleDayId ? (
          <AdvancedSchedPage advancedDay={advancedScheduleDayId} />
        ) : (
          <>
          <h4 className={`mt-5 pl-3 py-0 px-1 ${styles.SubTitleSpan }`} 
          style={{ textTransform: 'uppercase' }}>
            Advanced Schedule <span className={`${styles.HSpan }`} >
              Advanced Schedule Day to be selected
               </span>
          </h4>
          <hr className={`mb-0 pl-3 mt-0 pt-1 ${styles.Break5 }`}/>
          </>
        ) }
        {/* Walkie Channels */}
        <WalkiesPage />
      </div>
      {/* MOBILE  */}
      <div className="d-block d-md-none mb-5">
      {location_5_name && (
          <Row>
          <Col
            className={`text-center `}
            xs={{ span: 8, offset: 2 }}
          >
            <div className={`mx-3 pb-0 px-2 ${styles.CountryBack}`}>
            <h4 style={{ textTransform: 'uppercase'}} className={`mb-0 pb-0 ${styles.vv}`}>
              {location_5_name} SHOOT</h4>
            </div>
          </Col>
        </Row>
        ) }
        <div>
          {/* name */}
          <Row>
            <Col className="text-center" xs={{ span: 8, offset: 2 }}>
              <p className={`px-2 ${styles.MovieNameMo}`}>{production_name} </p>
            </Col>
            {/* {cUser &&
              cUser?.groups?.length > 0 &&
              (cUser?.groups[0]?.name === "Admin" ||
                cUser?.groups[0]?.name === "Superadmin") && (
                <Col className={`text-center px-0 ${styles.Icon}`} xs={2}>
                  <PostDropdown
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                  />
                </Col>
              )} */}
          </Row>
          {/* header */}
          <Row className="px-3">
            {/* weather/calls */}
            <Col className={`pl-0 pr-0`} xs={3}>
              {/* weather */}
              <div>
              <Row>
              <Col xs={12} >
              <p className={`mb-0 ${styles.BoldV}`} >Sunrise:</p>
              <p style={{ textTransform: 'uppercase'}}
              className={`${styles.WhiteAqua}`}>{location_3_name} </p> 
              <p className={`mb-0 {styles.Bold}`} >Sunset:</p>
              <p style={{ textTransform: 'uppercase'}} 
              className={`${styles.WhiteAqua}`}>{location_4_name} </p> 
              <p className={`mb-0 ${styles.Bold}`} >Weather:</p>
              <p className={`${styles.WhiteAqua}`} >{location_2_name}</p>
              </Col>
              </Row>
              </div>
            </Col>
            {/* logo calls */}
            <Col xs={6} className="px-0 mx-0 text-center">
              <h5 className={`my-0 pl-0 ${styles.WhiteAquaPro}`}>
                {production_company}{" "}
              </h5>
              <div className={`mt-1`}>
                {company_logo ? (
                  <>
                    <div className="px-3">
                      <Image
                        className={styles.LogoMo}
                        src={company_logo}
                        alt="logo image"
                      />
                    </div>
                  </>
                ) :
                <>
                    <div className="px-3">
                      <Image
                        className={styles.LogoMo}
                        src={sceneblue2}
                        alt="logo image"
                      />
                    </div>
                  </> 
                }
              </div>
              <div className="mt-2 mb-0 pb-0">
                <Row>
                <Col>
                <p className={`px-3 ${styles.UnitCallMobDate}`}>
                Day {day}
                </p>
                <p className={`px-3 ${styles.UnitCallMobDate}`}>
                  {date}
                </p>
                </Col>
                </Row>
            </div>
            <div className={`mx-2 mx-sm-3 mt-1 pb-0 px-sm-2 ${styles.CountryBack}`}>
              <h5 className={` mb-0 pb-0`}>SECOND UNIT</h5>
            </div>
            </Col>
            {/* calls */}
            <Col xs={3} className={`px-0`}>
              <div className={` mt-0`}>
                <p className={`mb-0`}>
                  <span className={`${styles.BoldV}`}>Cast Call:</span>{" "}
                </p>
                <p className={`${styles.WhiteAqua}`}>{talent_call} </p>
                <p className={`mb-0`}>
                  <span className={`${styles.Bold}`}>First Shot:</span>
                </p>
                <p className={`${styles.WhiteAqua}`}>{shoot_call}</p>
                <p className={`mb-0`}>
                  <span className={`${styles.Bold}`}>Est. Wrap:</span>{" "}
                </p>
                <p className={`${styles.WhiteAqua}`}>{wrap}</p>
              </div>
            </Col>
          </Row>
          <Row className="px-3">
          <Col xs={3} className={`px-0`}>
          {/* meals */}
          <div className={``}>
            <p className={`mb-0`}>
              <span className={`${styles.BoldU}`}>Breakfast:</span>
            </p>
            <p className={`${styles.WhiteAqua} mb-0`}>{breakfast}</p>
            <p className={` mb-0`}>
              <span className={`${styles.Bold}`}>Lunch:</span>{" "}
            </p>
            <p className={`${styles.WhiteAqua} mb-0`}>{lunch} </p>
          </div>
          </Col>
          <Col xs={6} className="text-center px-0" >
          <div className={`mt-1 mx-sm-3 pb-0 px-sm-2 ${styles.Border2}`}>
                <h5 className={`px-1 pb-0 mb-0 ${styles.UnitCallMob}`}>Unit Call</h5>
                <h5 className={`px-1 pb-0 mb-0 ${styles.UnitCallMob}`}>
                  {unit_call}{" "}
                </h5>
              </div>
              {/* loc */}
              <div className={`mt-0 mx-0 pb-0 px-0`}>
                <Row>
                  <Col xs={12}>
                  <p className={`mb-0 pt-0 text-center ${styles.Bold}`}>
                    1st Location
                  </p>
                    <p className={`mb-1 ${styles.WhiteAqua}`}>
                      {firstLoc}{" "}
                    </p>
                  </Col>
                </Row>
              </div>
          </Col>
          <Col xs={3} className={`px-0`}>
          <div >
          <p className={`mb-0`}>
            <span className={`${styles.BoldU}`}>Day:</span>{" "}
          </p>                
            <p className={`${styles.WhiteAqua}`}>
              {`Day ${day}`}
              </p>
              </div>
              <p className={`${styles.Bold} mb-0`}>User:</p>
              <p className={`${styles.WhiteAqua}`}> {firstname} {lastname}</p>
          </Col>
          </Row>
        </div>
        <p className={`mt-2 pl-3 mb-0 pt-1 ${styles.SubTitle}`}></p>
        {/* buttons */}
        <Row>
          <Col xs={{ span: 8, offset: 2 }} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowHos((showHos) => !showHos)}
            >
              Nearest Hospital
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={4} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowContacts((showContacts) => !showContacts)}
            >
              Contacts
            </p>
          </Col>
          <Col xs={4} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowLoc((showLoc) => !showLoc)}
            >
              Locations
            </p>
          </Col>
          <Col xs={4} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowWalkies((showWalkies) => !showWalkies)}
            >
              Walkies
            </p>
          </Col>
        </Row>
        <Row className={`${styles.ButtonLine} mt-0`}>
          <Col xs={4} md={2} className="text-center">
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowSched((showSched) => !showSched)}
            >
              {" "}
              Schedule
            </p>
          </Col>
          <Col xs={4} md={2} className="text-center">
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowTalent((showTalent) => !showTalent)}
            >
              {" "}
              Talent
            </p>
          </Col>
          <Col xs={4} className="mx-0 text-center py-0" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowBg((showBg) => !showBg)}
            >
              {" "}
              Background
            </p>
          </Col>
          <Col xs={4} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowNotes((showNotes) => !showNotes)}
            >
              Notes
            </p>
          </Col>
          <Col xs={4} className="mx-0 px-0 text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowCrew((showCrew) => !showCrew)}
            >
              {" "}
              Crew
            </p>
          </Col>
          <Col xs={4} className="mx-0 px-0 text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() =>
                setShowAdvanSched((showAdvanSched) => !showAdvanSched)
              }
            >
              {" "}
              Adv Schedule
            </p>
          </Col>
        </Row>
        <p className={`mt-1 pl-3 mb-0 py-1 ${styles.SubTitle}`}></p>
        {/* pages */}
        {!showHos ? (
          ""
        ) : (
          <HospitalPage
            callsheet={callsheet}
            crewInfoOne={crewInfoOne}
            setShow={setShowHos}
          />
        )}
        {!showContacts ? (
          ""
        ) : (
          <ContactsPage
            callsheet={callsheet}
            crewInfoOne={crewInfoOne}
            setShow={setShowContacts}
          />
        )}
        {!showLoc ? (
          ""
        ) : (
          <LocationsPage
            callsheet={callsheet}
            scenes={uniqueLocationScenes}
            setShow={setShowLoc}
          />
        )}
        {!showWalkies ? (
          ""
        ) : (
          <WalkiesPage setShow={setShowWalkies} />
        )}
        {!showSched ? (
          ""
        ) : (
          <SchedulePage
            scenes={scenes}
            callsheet={callsheet}
            setShow={setShowSched}
          />
        )}
        {!showTalent ? (
          ""
        ) : (
          <TalentPage
            handleMount={handleMount}
            cast={cast}
            callsheet={callsheet}
            setShow={setShowTalent}
          />
        )}
        {!showBg ? (
          ""
        ) : (
          <BgPage
            handleMount={handleMount}
            background={background}
            callsheet={callsheet}
            setShow={setShowBg}
          />
        )}
        {!showNotes ? (
          ""
        ) : (
          <NotesPage
            important_info={important_info}
            transport_info={transport_info}
            department_info={department_info}
            setShow={setShowNotes}
          />
        )}
        {!showCrew ? (
          ""
        ) : (
          <CrewCallsPage2 crewcalls={crewcalls} setShow={setShowCrew} />
        )}
        {!showAdvanSched ? (
          ""
        ) : (
          <>
          {advancedScheduleDayId ? (
           <AdvancedSchedPage
            advancedDay={advancedScheduleDayId}
            callsheet={callsheet}
            setShow={setShowAdvanSched}
          />
          ) : (
            <p>Advanced Schedule Day to be selected</p>
          ) }
          </>
          
        )}
      </div>
    </div>
  );
};

export default CallSheet2;
